export default __webpack_public_path__ + "static/media/Skagen-watch.850cd2d6.jpg";